// removed by extract-text-webpack-plugin
module.exports = {"card":"_157NmhbuE-QUQKxVUoWxkW","text":"ETZQ7t6bNrT0wmF-Ww-wS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InfographicsCard/InfographicsCard.module.scss
// module id = 781
// module chunks = 0